const RESPONSIVE_ROBOT = {
  RESPONSIVE_ROBOT_PAGE_TITLE: 'List',
  RESPONSIVE_ROBOT_ADD_FIELD_BTN: 'Add a new field',
  RESPONSIVE_ROBOT_INPUT_QUESTION_PLACEHOLDER: 'Question',
  RESPONSIVE_ROBOT_INPUT_RESPONSE_PLACEHOLDER: 'Response',
  RESPONSIVE_ROBOT_INPUT_LINK_PLACEHOLDER: 'Enter the link.',
  RESPONSIVE_ROBOT_SELECT_BOX_TITLE: 'Select Department',
  RESPONSIVE_ROBOT_ACTIVE: 'Active',
  RESPONSIVE_ROBOT_INACTIVE: 'InActive',
  RESPONSIVE_ROBOT_TABLE_TITLE_1: 'Title',
  RESPONSIVE_ROBOT_TABLE_TITLE_2: 'Status',
  RESPONSIVE_ROBOT_TABLE_TITLE_3: 'action',
  RESPONSIVE_ROBOT_TABLE_TITLE_4: 'Department',
  RESPONSIVE_ROBOT_TABLE_TITLE:
    ' Operations are defined for the responsive robot',
  RESPONSIVE_ROBOT_NEW_OPERATION_BUTTON: 'Create a new operation',
  RESPONSIVE_ROBOT_TABLE_BUTTON: 'List of Operations',
  RESPONSIVE_ROBOT_TABLE_EACH_ITEM_TITLE: 'Set Number ',
  RESPONSIVE_ROBOT_DELETE_MODAL:
    'Are you sure you want to delete the selected item?',
  RESPONSIVE_ROBOT_DELETE_MODAL_SUBMIT_BTN: 'Confirm',
  RESPONSIVE_ROBOT_LIST_EMPTY: 'No operations defined!',
  RESPONSIVE_ROBOT_FORM_SUBMIT: 'Publish',
  RESPONSIVE_ROBOT_FORM_CANCEL: 'Cancel',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_TEXT: 'Final Response',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_QUESTION: 'Question',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_EVENT: 'Event',
  RESPONSIVE_ROBOT_RESPONSE_TYPE_REDIRECT: 'Link',
  RESPONSIVE_ROBOT_FORM_TITLE: 'How can I help you?',
  RESPONSIVE_ROBOT_LEVEL_TITLE: 'Level 1',
  RESPONSIVE_ROBOT_ADD_NEW_FORM: 'Add New Question',
};

export default RESPONSIVE_ROBOT;
